// Valores gerados dinamicamente para fins informativos.
import {
  Flame,
  Rabbit,
  Beef,
  Sparkles,
  Cat,
  Skull,
  Zap,
  Candy,
} from "lucide-react";

export const SOCIALS = {
  instagram: "https://instagram.com/mangabetbr",
  telegram: "https://t.me/+aCN5MHuHSu1jMDk1",
  email: "mangovip@gmail.com",
};

export const PROVIDERS = ["PG Soft", "Pragmatic Play", "WG"];

export const LIVE_PROVIDERS = [
  {
    id: "pg",
    name: "PG Soft",
    tag: "Provedora Premium",
    accent: "#F5C542",
  },
  {
    id: "wg",
    name: "WG",
    tag: "Alta Frequência",
    accent: "#F28C28",
  },
  {
    id: "pragmatic",
    name: "Pragmatic Play",
    tag: "Volatilidade Elevada",
    accent: "#FFD84D",
  },
];

export const GAMES = [
  {
    id: "fortune-tiger",
    name: "Fortune Tiger",
    provider: "PG Soft",
    icon: Flame,
    color: "#F28C28",
    hot: true,
  },
  {
    id: "fortune-rabbit",
    name: "Fortune Rabbit",
    provider: "PG Soft",
    icon: Rabbit,
    color: "#FFD84D",
    hot: true,
  },
  {
    id: "fortune-ox",
    name: "Fortune Ox",
    provider: "PG Soft",
    icon: Beef,
    color: "#F5C542",
    hot: false,
  },
  {
    id: "fortune-dragon",
    name: "Fortune Dragon",
    provider: "PG Soft",
    icon: Sparkles,
    color: "#F28C28",
    hot: false,
  },
  {
    id: "lucky-neko",
    name: "Lucky Neko",
    provider: "PG Soft",
    icon: Cat,
    color: "#FFD84D",
    hot: false,
  },
  {
    id: "wild-bandito",
    name: "Wild Bandito",
    provider: "PG Soft",
    icon: Skull,
    color: "#F5C542",
    hot: true,
  },
  {
    id: "gates-olympus",
    name: "Gates of Olympus",
    provider: "Pragmatic Play",
    icon: Zap,
    color: "#F28C28",
    hot: true,
  },
  {
    id: "sweet-bonanza",
    name: "Sweet Bonanza",
    provider: "Pragmatic Play",
    icon: Candy,
    color: "#FFD84D",
    hot: false,
  },
];

export const STATS = [
  { id: "rtp", label: "Precisão Média", value: 96.7, suffix: "%", decimals: 1 },
  { id: "games", label: "Jogos Monitorados", value: 128, suffix: "+", decimals: 0 },
  { id: "updates", label: "Atualizações / Dia", value: 8640, suffix: "", decimals: 0 },
  { id: "users", label: "Usuários Online", value: 2417, suffix: "", decimals: 0 },
];

const HORARIOS = ["09:20", "12:45", "15:10", "18:30", "20:15", "22:40", "23:55"];
const SEQ = [
  "10 → 25 → 40",
  "5 → 15 → 30",
  "8 → 22 → 45",
  "12 → 28 → 50",
  "6 → 18 → 36",
];

const rand = (min, max) => Math.random() * (max - min) + min;
export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function rtpLevel(rtp) {
  if (rtp >= 96.5) return { key: "high", label: "Alto", color: "#00FF41" };
  if (rtp >= 93) return { key: "medium", label: "Médio", color: "#FFD84D" };
  return { key: "low", label: "Baixo", color: "#FF3B30" };
}

export function genLiveRtp() {
  const rtp = +rand(88, 98.5).toFixed(2);
  const vol = pick(["Baixa", "Média", "Alta"]);
  return { rtp, vol, level: rtpLevel(rtp), updated: new Date() };
}

export function genSignal() {
  const game = pick(GAMES);
  const rtp = +rand(94, 98.9).toFixed(2);
  return {
    provider: game.provider,
    game: game.name,
    rtp,
    time: pick(HORARIOS),
    confidence: Math.round(rand(82, 98)),
    sequence: pick(SEQ),
    level: rtpLevel(rtp),
  };
}

export function genRanking() {
  return GAMES.map((g) => {
    const rtp = +rand(90, 98.8).toFixed(2);
    return {
      ...g,
      rtp,
      level: rtpLevel(rtp),
      updated: `${Math.floor(rand(1, 12))} min atrás`,
    };
  }).sort((a, b) => b.rtp - a.rtp);
}

export function genChartData() {
  const hours = 24;
  const out = [];
  let v = 95;
  for (let i = 0; i < hours; i++) {
    v += rand(-1.4, 1.5);
    v = Math.min(98.5, Math.max(91, v));
    out.push({ hora: `${String(i).padStart(2, "0")}h`, rtp: +v.toFixed(2) });
  }
  return out;
}

export function genUpdates() {
  return GAMES.slice(0, 5).map((g) => {
    const rtp = +rand(92, 98.5).toFixed(2);
    return {
      game: g.name,
      provider: g.provider,
      rtp,
      level: rtpLevel(rtp),
      time: `${Math.floor(rand(1, 40))} seg atrás`,
    };
  });
}
